export const getUserToken = () => localStorage?.getItem("auth_token");
export const getBigShipToken = () => localStorage?.getItem("bigship_token");
export const lastTokenStoreTime = () => localStorage?.getItem("last_token_store_time");

export const getUserData = () => {
    try {
        const raw = localStorage.getItem("user");
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const getUserId = () => getUserData()?.id;
export const getUserRole = () => getUserData()?.role ?? "";

export const normalizeUserRole = (role) => String(role ?? "").trim().toLowerCase();

export const DASHBOARD_LOGIN_ROLES = [
    "admin",
    "staff",
    "hr-admin",
    "b2b-salesperson",
    "calling",
];

/** staff-admin-login: accept when backend returns token + user (role optional fallback list). */
export const isAllowedDashboardLogin = (user, token) => {
    if (!token || !user) return false;
    const role = normalizeUserRole(user.role);
    if (!role) return true;
    return DASHBOARD_LOGIN_ROLES.includes(role);
};

export const getPostLoginPath = (role) => {
    const normalized = normalizeUserRole(role);
    if (normalized === "admin") return "/farmers";
    if (normalized === "hr-admin") return "/dashboard";
    if (normalized === "b2b-salesperson") return "/b2b-sales-person-view";
    return "/b2c-sales-person-view";
};

export const isB2bSalesperson = () => normalizeUserRole(getUserRole()) === "b2b-salesperson";

/** Staff + B2B salesperson — scoped to own orders/leads on list APIs. */
export const isSalesStaffRole = () =>
    normalizeUserRole(getUserRole()) === "staff" || isB2bSalesperson();
